import { api } from "@/lib/api-client";
import type { Page } from "@/admin/api";

// The generic admin engine: every section described server-side in
// admin_resources.rs is listed, shown and edited through these calls.

export type FieldType =
  | "text"
  | "longtext"
  | "int"
  | "bool"
  | "choice"
  | "json"
  | "datetime"
  | "cents"
  | "millicents"
  | "token_price"
  | "tenant"
  | "ref"
  | "secret";

export type FieldSpec = {
  name: string;
  label: string;
  type: FieldType;
  choices?: [string, string][];
  edit: boolean;
  list: boolean;
  help: string;
};

export type ResourceSchema = {
  key: string;
  title: string;
  singular: string;
  description: string;
  fields: FieldSpec[];
  search: boolean;
  filters: string[];
  create: boolean;
  delete: boolean;
  actions: { key: string; label: string }[];
};

export type Row = Record<string, unknown> & { id: string };

export const resourceApi = {
  schema: async (key: string) =>
    (await api.get<ResourceSchema>(`/admin/resources/${key}/schema/`)).data,
  list: async (key: string, params: Record<string, string | number | undefined>) =>
    (await api.get<Page<Row>>(`/admin/resources/${key}/`, { params })).data,
  get: async (key: string, id: string) =>
    (await api.get<Row>(`/admin/resources/${key}/${id}/`)).data,
  create: async (key: string, data: Record<string, unknown>) =>
    (await api.post<Row>(`/admin/resources/${key}/`, data)).data,
  update: async (key: string, id: string, data: Record<string, unknown>) =>
    (await api.patch<Row>(`/admin/resources/${key}/${id}/`, data)).data,
  remove: async (key: string, id: string) => {
    await api.delete(`/admin/resources/${key}/${id}/`);
  },
  action: async (key: string, id: string, action: string) =>
    (await api.post<Row>(`/admin/resources/${key}/${id}/actions/${action}/`)).data,
};
